import { QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { RouterProvider, createRouter } from '@tanstack/react-router'
import { queryClient } from './api/queryClient'
import { routeTree } from './routeTree.gen'
import './i18n'

// QueryClient is a module-level singleton (see src/api/queryClient.ts) so that
// `useWorkspaceStore.switchWorkspace` can call `queryClient.removeQueries`
// against the SAME cache that this provider exposes to the component tree.
const router = createRouter({ routeTree })

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
      {/* Devtools are gated by `import.meta.env.DEV` so Vite tree-shakes the
          import out of the production bundle (see PRD NFR-PERF-03 budget). */}
      {import.meta.env.DEV && <ReactQueryDevtools initialIsOpen={false} />}
    </QueryClientProvider>
  )
}
